export * from './TaskDetails.component';
